module.exports = __webpack_public_path__ + "img/remove_src_1.3f5c59f8.webp";